var map = {
	"./15m_sprint_card.svg": "b268",
	"./ball_wall_card.svg": "59ef",
	"./catching_card.svg": "2e09",
	"./cooper_run_card.svg": "23ec",
	"./football_dribbling_card.svg": "d9d0",
	"./handeye_card.svg": "48d5",
	"./keepy_uppy_card.svg": "c687",
	"./long_jump_card.svg": "6736",
	"./parnter_work_card.svg": "6b9c",
	"./plank_card.svg": "5f6a",
	"./pushup_card.svg": "4b65",
	"./reaction_card.svg": "08a2",
	"./shuttle_run_card.svg": "1548",
	"./sit_reach_card.svg": "cbf3",
	"./situp_card.svg": "2b65",
	"./skipping_card.svg": "982c",
	"./speed_bounce_card.svg": "eb74",
	"./stepup_card.svg": "3c44",
	"./stork_balance_card.svg": "83cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad80";